import React from 'react';
import HeadingBlock from '$/components/global/heading';

const NotFound: React.FC = () => {
  return (
    <React.Fragment>
      <section>
        <HeadingBlock title="Not Found" titleOnly />
      </section>
    </React.Fragment>
  );
};

export default NotFound;
